<script>
export default {
   created() 
  {
  
   const url=window.location.href;
   document.location = "sghealth://singpass-callback?"+url.split("?")['1'];
        
   
  },
};
</script>


